import { Link } from "react-router-dom";

const quickLinks = [
  { label: "神翻译合集", to: "/collections" },
  { label: "避雷区", to: "/avoid" },
  { label: "翻译对比", to: "/compare" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

const tags = ["神翻译合集", "润色版推荐", "烂翻译避雷", "翻译对比", "嵌字吐槽", "删页对比"];

export default function Footer() {
  return (
    <footer className="bg-secondary-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
                <i className="ri-fire-fill" aria-hidden="true"></i>
              </span>
              <span className="font-label text-xl text-foreground-950">
                炮渣<span className="text-primary-600">漫画网</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              神翻译合集与润色版推荐，翻译对比看清删页差异。嵌字吐槽与质量差作品避雷，帮你避开烂翻译烂嵌字，只看舒服版本。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {tags.map((t) => (
                <span
                  key={t}
                  className="rounded-full bg-secondary-200 px-3 py-1 text-xs text-secondary-900"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-base font-semibold text-foreground-950">快速导航</h4>
            <ul className="mt-4 flex flex-col gap-3">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-foreground-700 hover:text-primary-600">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading text-base font-semibold text-foreground-950">栏目定位</h4>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-foreground-700">
              <li>· 神翻译：逐话对比精选的润色佳作</li>
              <li>· 避雷：机翻、删页、嵌字粗糙的坑</li>
              <li>· 对比：同作品多版本差异截图</li>
              <li>· 吐槽：汉化行业内的常见乱象</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-secondary-300 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} 炮渣漫画网 · 本网站仅做汉化质量评测与推荐，不提供任何盗版资源。
          </p>
          <p className="text-xs text-foreground-600">翻译对比 · 嵌字吐槽 · 只看舒服版本</p>
        </div>
      </div>
    </footer>
  );
}